export const STORE_CENTERS = 'STORE_CENTERS'

export const LOGIN = 'LOGIN'

export const LOGOUT = 'LOGOUT'
